import { Dialog } from '@base-ui/react/dialog'
import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

interface ModalProps {
  open: boolean
  onClose: () => void
  /** The h3. Also the dialog's accessible name. */
  title: ReactNode
  /** The body: paragraphs (`.modal p` styles them), fields, a `<WizardSteps>`. */
  children: ReactNode
  /** The button row (`.mrow`), right-aligned. Put the confirming action last. */
  actions?: ReactNode
  /** Wizards are 580px wide instead of 480px (`.mbox.wiz`). */
  wide?: boolean
  /** For the wizard: lay the row out space-between (Back on the left). */
  actionsBetween?: boolean
}

/**
 * A centred dialog (`.modal` > `.mscrim` + `.mbox`). Base UI's Dialog supplies the
 * focus trap, Escape, outside click and focus return; the look is the prototype's.
 */
export function Modal({ open, onClose, title, children, actions, wide, actionsBetween }: ModalProps) {
  return (
    <Dialog.Root open={open} onOpenChange={(next) => (next ? undefined : onClose())}>
      <Dialog.Portal className="console-layer modal on">
        <Dialog.Backdrop className="mscrim" />
        <Dialog.Popup className={cn('mbox', wide && 'wiz')}>
          <Dialog.Title render={<h3 />}>{title}</Dialog.Title>
          {children}
          {actions ? (
            <div className="mrow" style={actionsBetween ? { justifyContent: 'space-between' } : undefined}>
              {actions}
            </div>
          ) : null}
        </Dialog.Popup>
      </Dialog.Portal>
    </Dialog.Root>
  )
}

/** A button that closes the surrounding Modal or Drawer. Style it with `className="btn btn--quiet"`. */
export const ModalClose = Dialog.Close
